<template>
    <div class="add-matrix">
      <div class="file-block">
        <div v-show="!selectedFile" class="set-file-btn">
          <label for="file-input-matrix" class="file-label">Загрузить фаил</label>
          <input id="file-input-matrix" type="file" ref="fileInput" accept=".xlsx, .xls" class="file-input-matrix" @change="handleFileChange" />
        </div>
        <!-- <p v-if="selectedFile" class="file-name">{{selectedFile.substring(0, 15)}}...</p> -->
      </div>
      
      <div>
        
        <button 
        v-if="selectedFile" 
        @click="submit" 
        class="upload-button">
        <p v-if="loading"><mini-loader ></mini-loader></p>
        <p v-else>Отправить</p>
        </button>
      </div>
    </div>
  </template>
  
  <script>
  import { ref } from 'vue';
  import ApiConnector from '@/backend/apiModels/userApi'
  import { createToaster } from "@meforma/vue-toaster";
  import { useErrorHandler } from '@/hooks/errorHandler';
  
  export default {
    name: 'UploadRoutes',
    setup() {
      const loading = ref(false)
      const fileInput = ref(null);
      const selectedFile = ref('');
      const api = new ApiConnector()
      const toaster = createToaster()
  
      const handleFileChange = () => {
        const file = fileInput.value.files[0];
        if (file) {
          selectedFile.value = file.name;
        } else {
          selectedFile.value = '';
        }
      };
  
      
      const submit = async () => {
        const file = fileInput.value.files[0];
        if (file && !loading.value) {
          try{
            loading.value = true
            const { response, request } = api.updateCustomerTable('ati/file',file);
            await request();
            toaster.success(response.value.msg)  
          }catch(err){
            useErrorHandler(err)
          }
          
        }
        fileInput.value = ''
        selectedFile.value = ''
        loading.value = false
      }
  
      return {
        loading,
        fileInput,
        selectedFile,
        handleFileChange,
        submit,
      };
    },
  };
  </script>
  
  <style scoped>
  .add-matrix {
    display: flex;
    flex-direction: column;
  }
  
  .file-block{
    display: flex;
    align-items: center;
  }
  
  .file-label {
    margin-left: 10px;
    margin-right: 15px;
    padding: 10px;
    background-color: #28a745;
    color: #fff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
  
  .file-label:hover {
    background-color: #0e6572;
  }
  
  .file-label:active {
    background-color: #0e6572;
  }
  
  .file-input-matrix {
    display: none;
  }
  
  .file-name{
    margin-left: 10px;
  }
  
  .upload-button {
    height: 38px;
    margin-left: 10px;
    margin-right: 15px;
    padding: 10px;
    background-color: #28a745;
    color: #fff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
  
  .upload-button:hover {
    background-color: #0e6572;
  }
  
  .upload-button:active {
    background-color: #0e6572;
  }
  
  .upload-button:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.5);
  }
  
  .loader {
    max-width: 20px;
    max-width: 20px;
  }
  </style>
  